import React, { useState } from "react";
import {
  Button,
  CustomInput,
  CustomSelect,
  FormFieldSet,
  InfoTimeCard,
  InfoTimeCardAdv,
  Modal,
  TableAdv,
  PageHeader,
  PageTitle,
  Tag,
  useFormHandler,
  InfoCardNewAdv,
} from "../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../utils";
import { discountOptions } from "../../../../../assets/data/projectData";
import PaymentDiscountModal from "./Modals/PaymentDiscountModal";
import InvoiceDiscountModal from "./Modals/InvoiceDiscountModal";

const ReceivePayment = ({ onBack }) => {
  const { formData, errors, handleChange } = useFormHandler(
    {
      selectClient: "",
      paymentReceivedDate: "",
      amountReceived: "",
      paymentMethod: "",
      accountType: "",
      referenceNo: "",
      comments: "",
      attachment: [],
    },
    {
      referenceNo: {
        type: "text",
        required: true,
        numwdec: true,
      },
      attachment: { type: "file" },
    },
  );

  const [selectedRows, setSelectedRows] = useState([]);
  const [paymentAmounts, setPaymentAmounts] = useState({});

  // Modal states
  const [isInvoiceDiscountModalOpen, setIsInvoiceDiscountModalOpen] =
    useState(false);
  const [isPaymentDiscountModalOpen, setIsPaymentDiscountModalOpen] =
    useState(false);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [tableData, setTableData] = useState([
    {
      id: 1,
      invoiceNumber: "16444",
      activity: "03/01/2025-03/31/2025",
      subcustomer: "--",
      invoiceDate: "2025-04-04T00:00:00.000Z",
      dueDate: "2025-05-19T00:00:00.000Z",
      invoiceAmount: "12768.00",
      paymentReceived: "12768.00 USD",
      balance: "12768.00 USD",
      enterPaymentAmount: "12768",
      paymentDiscount: "0.00 USD",
    },
    {
      id: 2,
      invoiceNumber: "16436",
      activity: "03/01/2025-03/31/2025",
      subcustomer: "--",
      invoiceDate: "2025-04-04T00:00:00.000Z",
      dueDate: "2025-05-19T00:00:00.000Z",
      invoiceAmount: "12768.00",
      paymentReceived: "12768.00 USD",
      balance: "12768.00 USD",
      enterPaymentAmount: "12768",
      paymentDiscount: "0.00 USD",
    },
    {
      id: 3,
      invoiceNumber: "16435",
      activity: "03/01/2025-03/31/2025",
      subcustomer: "--",
      invoiceDate: "2025-04-04T00:00:00.000Z",
      dueDate: "2025-05-19T00:00:00.000Z",
      invoiceAmount: "12768.00",
      paymentReceived: "0.00 USD",
      balance: "12768.00 USD",
      enterPaymentAmount: "12768",
      paymentDiscount: "0.00 USD",
    },
  ]);

  const handleChangeTable = (field, row, value) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, [field]: value } : item,
      ),
    );
  };

  const handleDiscountSelect = (value, row) => {
    setCurrentRowData(row);

    if (value === "Invoice Discount") {
      setIsInvoiceDiscountModalOpen(true);
    } else if (value === "Payment Discount") {
      const enteredAmountStr = paymentAmounts[row.id] || "0";
      // const enteredAmount = parseFloat(enteredAmountStr.replace(/,/g, ""));

      // Parse paymentReceived (e.g., "0.00 USD" → 0.00)
      const paymentReceived = parseFloat(
        row.paymentReceived.replace(/,/g, "").split(" ")[0],
      );

      // Parse invoiceAmount (e.g., "12768.00" → 12768.00)
      const invoiceAmount = parseFloat(row.invoiceAmount.replace(/,/g, ""));

      // Check if enteredAmount + paymentReceived equals invoiceAmount
      // if (enteredAmount + paymentReceived === invoiceAmount) {
      if (paymentReceived === invoiceAmount) {
        console.log("consoleo triggger");
        setAlertMessage(
          "Cannot apply Discounts to this payment as received amount is equal to open balance.",
        );
        setIsAlertModalOpen(true);
      } else {
        setIsPaymentDiscountModalOpen(true);
      }
    }
  };

  console.log("paymentAmounts :", paymentAmounts);

  const columns = [
    {
      key: "invoiceNumber",
      label: "Invoice Number",
      render: (row) => (
        <div className="flex items-center gap-1 cursor-pointer">
          <span className="text-linkblue cursor-pointer">
            {row.invoiceNumber}
          </span>
        </div>
      ),
    },
    {
      key: "activity",
      label: "Statement Memo Period",
    },
    {
      key: "subcustomer",
      label: "Subcustomer",
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
    },
    {
      key: "dueDate",
      label: "Due Date",
      render: (row) => dateFormator(row.dueDate, "month-day-year"),
    },
    {
      key: "invoiceAmount",
      label: "Invoice Amount",
    },
    {
      key: "paymentReceived",
      label: "Payment Received",
    },
    {
      key: "balance",
      label: "Balance",
    },
    {
      key: "enterPaymentAmount",
      label: "Enter Payment Amount",
      render: (row) => (
        <div>
          <CustomInput
            type="text"
            placeholder=""
            title=""
            size={"xs"}
            value={row?.enterPaymentAmount}
            onChange={(e) => handleChangeTable("enterPaymentAmount", row, e)}
          />
        </div>
      ),
    },
    {
      key: "paymentDiscount",
      label: "Payment Discount",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <CustomSelect
            type="select"
            title={""}
            placeholder="Discounts"
            size="xs"
            options={discountOptions}
            onChange={(value) => handleDiscountSelect(value, row)}
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  // Handle selection change from TableAdv
  const handleSelectionChange = (selectedRowIds) => {
    console.log("Selected row IDs:", selectedRowIds);
    setSelectedRows(selectedRowIds);

    // Find the actual row objects from mappedRows
    const selectedRowObjects = mappedRows.filter((row) =>
      selectedRowIds.includes(row.id),
    );

    console.log("Selected row objects:", selectedRowObjects);
  };

  return (
    <div className="w-full">
      <div>
        <PageHeader
          Section={
            <div className="flex gap-3">
              <PageTitle title={"CREATE CLIENT PAYMENT"} tag="p" size={"sm"} />
              <Tag
                title="Tektree"
                variant="outlined"
                className=" !text-neutrals !py-1.5"
              />
            </div>
          }
          RightSection={
            <div className="flex gap-3">
              <Button
                size="sm"
                title={"Back"}
                icon={"arrow_left_alt"}
                onClick={onBack}
              />
              <Button size="sm" title={"Available Credits"} />
            </div>
          }
        />
        <div>
          <PageHeader
            RightSection={
              <div className="flex gap-3 mt-3">
                {/* <InfoTimeCardAdv
                  title={"Amout Used"}
                  value={"12776.72"}
                  color="info"
                  size="xs"
                  prefix=""
                  suffix="USD"
                />
                <InfoTimeCardAdv
                    title={"Credit Available"}
                    value={"0.00"}
                    color="success"
                    size="xs"
                    prefix=""
                    suffix="USD"
                  />
                <InfoTimeCardAdv
                    title={"Amout Used"}
                    value={"0.00"}
                    color="info"
                    size="xs"
                    prefix=""
                    suffix="USD"
                  />
                <InfoTimeCardAdv
                    title={"Total Amout in Payment"}
                    value={"12776.72"}
                    color="primary"
                    size="xs"
                    prefix=""
                    suffix="USD"
                  /> */}
                <InfoCardNewAdv
                  title={"Amout Used"}
                  value={"12776.72"}
                  suffix="USD"
                  layout="option12"
                  valueConfig={{ className: "text-info!", decimals: 2 }}
                  suffixConfig={{ className: "text-info! font-normal!" }}
                />
                <InfoCardNewAdv
                  title={"Credit Available"}
                  value={"0.00"}
                  suffix="USD"
                  layout="option12"
                  valueConfig={{ className: "text-success!", decimals: 2 }}
                  suffixConfig={{ className: "text-success! font-normal!" }}
                />

                <InfoCardNewAdv
                  title={"Amout Used"}
                  value={"0.00"}
                  suffix="USD"
                  layout="option12"
                  valueConfig={{ className: "text-info!", decimals: 2 }}
                  suffixConfig={{ className: "text-info! font-normal!" }}
                />

                <InfoCardNewAdv
                  title={"Total Amout in Payment"}
                  value={"12776.72"}
                  suffix="USD"
                  layout="option12"
                  valueConfig={{ decimals: 2 }}
                  suffixConfig={{ className: "font-normal!" }}
                />
              </div>
            }
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 max-w-7xl gap-x-6 gap-y-8 mt-3">
          <FormFieldSet
            type="select"
            title={"Select Client"}
            placeholder="VDart Inc | CLN-001"
            value={formData.selectClient}
            onChange={(value) => handleChange("selectClient", value)}
            error={errors.selectClient}
          />
          <FormFieldSet
            type="datepicker"
            title={"Payment Received Date"}
            placeholder="04/05/2025"
            value={formData.paymentReceivedDate}
            onChange={(value) => handleChange("paymentReceivedDate", value)}
            error={errors.paymentReceivedDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="text"
            title={"Amount Received"}
            placeholder="12768.00"
            value={formData.amountReceived}
            onChange={(value) => handleChange("amountReceived", value)}
            error={errors.amountReceived}
          />
          <FormFieldSet
            type="select"
            title={"Payment Method"}
            placeholder="VDart Inc | CLN-001"
            value={formData.paymentMethod}
            onChange={(value) => handleChange("paymentMethod", value)}
            error={errors.paymentMethod}
          />
          <FormFieldSet
            type="select"
            title={"Account Type"}
            placeholder="VDart Inc | CLN-001"
            value={formData.accountType}
            onChange={(value) => handleChange("accountType", value)}
            error={errors.accountType}
          />
          <FormFieldSet
            type="text"
            title={"Reference No"}
            placeholder="Enter"
            value={formData.referenceNo}
            onChange={(value) => handleChange("referenceNo", value)}
            error={errors.referenceNo}
          />
          <FormFieldSet
            type="textArea"
            title={"Comments"}
            placeholder="Enter"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
          />
          <FormFieldSet
            type="file"
            title={"Attachment"}
            placeholder="Choose File"
            value={formData.attachment}
            onChange={(value) => handleChange("attachment", value)}
            error={errors.attachment}
          />
        </div>
        <div className="flex-1 flex overflow-hidden mt-4">
          <TableAdv
            tableId="receive-payment-client-table"
            rows={mappedRows}
            columns={columns}
            showCheckbox
            onSelectionChange={handleSelectionChange}
            defaultSelectedRows={selectedRows}
            toolbarRight={{
              filter: false,
              search: true,
            }}
          />
        </div>
      </div>

      {/* Modals */}
      <PaymentDiscountModal
        open={isPaymentDiscountModalOpen}
        onClose={() => setIsPaymentDiscountModalOpen(false)}
        rowData={currentRowData}
      />

      <InvoiceDiscountModal
        open={isInvoiceDiscountModalOpen}
        onClose={() => setIsInvoiceDiscountModalOpen(false)}
        rowData={currentRowData}
      />

      <Modal
        isOpen={isAlertModalOpen}
        onClose={() => setIsAlertModalOpen(false)}
        title="ALERT"
        width="max-w-2xl"
      >
        <div className="flex flex-col">
          {alertMessage}
          <div className="mt-8 flex justify-center items-end">
            <Button
              title={"Close"}
              onClick={() => setIsAlertModalOpen(false)}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ReceivePayment;
